// eslint-disable-next-line import/no-cycle
import api from '@/services/api';

export default {
  async fetchPendentes({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);

    const params = new URLSearchParams();

    keys.forEach((key) => {
      const value = payload[key];
      if (Array.isArray(value)) {
        params.append(key, value.join(','));
      } else if (typeof value === 'object' && value !== null) {
        Object.keys(value).forEach((subKey) => {
          params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
        });
      } else if (value) {
        params.append(key, value);
      }
    });

    dispatch('toggleLoading', true, { root: true });

    const response = await api.get('/processo/processos-pendentes/listar', { params });

    commit('SET_PENDENTES', response.data.registros.data);
    commit('paginacao/SET_PAGINADOR', response.data.registros, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async prepararExcel() {
    const { data } = await api.get('/processo/processos-pendentes/excel');

    return data;
  },
  async filtrar({ commit }, payload) {
    return commit('SET_FILTROS', payload);
  },
};
